import { render, staticRenderFns } from "./PopOrderMarker.vue?vue&type=template&id=c6fa5f20&scoped=true&"
import script from "./PopOrderMarker.vue?vue&type=script&lang=js&"
export * from "./PopOrderMarker.vue?vue&type=script&lang=js&"
import style0 from "./PopOrderMarker.vue?vue&type=style&index=0&id=c6fa5f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fa5f20",
  null
  
)

export default component.exports